

































































































































































import {
  computed,
  defineComponent,
  ref,
  useRoute,
  useRouter,
  PropType,
  watch
} from '@nuxtjs/composition-api'
import { Icon } from '~/models/common/types'

import SideHeaderMenuItem from '~/components/shared/side-header/SideHeaderMenuItem.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import { useNamespacedStore } from '~/compositions/store'
import { APP_NS, AppState } from '~/store/modules/shared/app/state'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'
import { USER_NS } from '~/store/modules/shared/user/state'
import { capitalizeString } from '~/utils/string'
import { I18nLocale } from '~/models/shared/types'
import { I18N_NS } from '~/store/modules/shared/i18n/state'
import { ciSearchbarMagnifier } from '~/icons/source/regular/searchbar-magnifier'
import { useDeps } from '~/compositions/dependency-container'
import SideHeaderBottomMenuItem from '~/components/shared/side-header/SideHeaderBottomMenuItem.vue'
import LanguageSwitcher from '~/services/LanguageSwitcher'
import UserDropdownContent from '~/components/car/header/UserDropdownContent.vue'
import { ciAngleDownLight } from '~/icons/source/solid/angle-down-light'

export interface SideHeaderMenu {
  label: string | number
  routeName: (e: Event) => unknown
  icon: Icon
}

export default defineComponent({
  components: {
    UserDropdownContent,
    SideHeaderBottomMenuItem,
    CAvatar,
    CImg,
    SideHeaderMenuItem
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    menuEntries: {
      type: Array as PropType<SideHeaderMenu[]>,
      required: true
    },
    bottomMenuEntries: {
      type: Array as PropType<SideHeaderMenu[]>,
      default: () => []
    }
  },
  setup() {
    const { getters: appGetters } = useNamespacedStore<AppState>(APP_NS)
    const { state: userState } = useNamespacedStore<AppState>(USER_NS)
    const { getters: i18nGetters } = useNamespacedStore<AppState>(I18N_NS)
    const isPlot = computed(() => appGetters('isPlot'))
    const [languageSwitcher] = useDeps(LanguageSwitcher)
    const router = useRouter()
    const route = useRoute()

    const hover = ref(false)
    const forceExpand = ref(false)
    const userDropdownRef = ref(null)
    const availableLocales = ref(languageSwitcher.getAvailableLocales())

    const avatar = computed(() => userState.avatar)
    const username = computed(() => userState.name)

    watch(route, val => {
      availableLocales.value = languageSwitcher.getAvailableLocales(val)
    })

    const onMouseLeave = () => {
      if (hover.value) {
        hover.value = false
      }
    }

    const onItemClick = () => {
      hover.value = false
    }

    const siteLogo = computed(() => {
      if (isPlot.value) {
        return require('~/assets/img/plot/index/plot-app.png')
      }
      return require('~/assets/img/plot/index/car-app.png')
    })
    const siteName = computed(() => {
      return capitalizeString(appGetters('domain'))
    })

    const locale = computed(() => i18nGetters('locale'))
    const localeCodeToFlag = computed(
      () =>
        new Map([
          [I18nLocale.EN, require('~/assets/img/flags/1x1/en.svg')],
          [I18nLocale.EL, require('~/assets/img/flags/1x1/el.svg')]
        ])
    )

    const nuxtLinkClicked = (link: string) => {
      hover.value = false

      if (router.resolve({ path: link }).resolved.name !== route.value.name) {
        return router.push({
          path: link
        })
      }
    }

    const expanded = computed(() => hover.value || forceExpand.value)

    const onItemsHover = () => {
      if (userDropdownRef.value) {
        userDropdownRef.value.hide()
      }
      hover.value = true
    }

    return {
      siteLogo,
      hover,
      expanded,
      forceExpand,
      onMouseLeave,
      onItemClick,
      avatar,
      username,
      siteName,
      locale,
      localeCodeToFlag,
      ciSearchbarMagnifier,
      languageSwitcher,
      nuxtLinkClicked,
      ciAngleDownLight,
      userDropdownRef,
      onItemsHover,
      availableLocales
    }
  }
})
